module.exports = __webpack_public_path__ + "static/img/bg.0a1c80f2.png";